import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const KonturDiadoc = (props: TIconProps): ReactElement => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <g id="konturdiadoc_layer_1_">
      <defs>
        <rect id="konturdiadoc_SVGID_1_" width="24" height="24" />
      </defs>
      <clipPath id="konturdiadoc_SVGID_2_">
        <use
          xlinkHref="#konturdiadoc_SVGID_1_"
          style={{ overflow: "visible" }}
        />
      </clipPath>
      <g clipPath="url(#konturdiadoc_SVGID_2_)">
        <path
          fill="hsl(from hsl(200 100% 39%) h s 50%)"
          d="M18,0H6C2.7,0,0,2.7,0,6v12c0,3.3,2.7,6,6,6h12c3.3,0,6-2.7,6-6V6C24,2.7,21.3,0,18,0z"
        />
        <path
          fill="#ffffff"
          d="M7.7,5.5c0.2-0.8,1-1.3,1.8-1.3h7.4c1,0,1.9,0.8,1.9,1.9v12c0,1-0.8,1.9-1.9,1.9h-11c-1.3,0-2.2-1.2-1.8-2.4
			L7.7,5.5z"
        />
        <path
          fill="none"
          stroke="hsl(from hsl(200 100% 39%) h s 13%)"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M11.1,7.7h3.6c0.2,0,0.4,0.2,0.4,0.4v7.1"
        />
        <path
          fill="none"
          stroke="hsl(from hsl(200 100% 39%) h s 13%)"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M8.5,17.1L8,15.4c0-0.1,0.1-0.2,0.2-0.2h8.1c0.1,0,0.2,0.1,0.2,0.2l-0.5,1.6"
        />
        <path
          fill="none"
          stroke="hsl(from hsl(200 100% 39%) h s 13%)"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9.2,12.6h3.6"
        />
        <path
          fill="none"
          stroke="hsl(from hsl(200 100% 39%) h s 13%)"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9.8,10.3h3"
        />
      </g>
    </g>
  </svg>
);
